// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var FileLoader = require("../utils/FileLoader.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var MM_wrk_client = require("../worker/MM_wrk_client.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var MM_wrk_LoadCtx = require("../worker/MM_wrk_LoadCtx.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var MM_wrk_ParseMmFile = require("../worker/MM_wrk_ParseMmFile.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Button = require("@mui/material/Button").default;
var AccordionSummaryStyled = require("../ui-utils/AccordionSummaryStyled.res.js");
var Add = require("@mui/icons-material/Add").default;
var Accordion = require("@mui/material/Accordion").default;
var IconButton = require("@mui/material/IconButton").default;
var ExpandMore = require("@mui/icons-material/ExpandMore").default;
var AccordionDetails = require("@mui/material/AccordionDetails").default;
var MM_cmp_context_selector_single = require("./MM_cmp_context_selector_single.res.js");

function createEmptySingleScope(id, srcType) {
  return {
          id: id,
          srcType: srcType,
          fileSrc: undefined,
          fileText: undefined,
          ast: undefined,
          allLabels: [],
          readInstr: "ReadAll",
          label: undefined,
          resetNestingLevel: true
        };
}

function setFileSrc(ss, fileSrc) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label,
          resetNestingLevel: ss.resetNestingLevel
        };
}

function setFileText(ss, fileText) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label,
          resetNestingLevel: ss.resetNestingLevel
        };
}

function setAst(ss, ast) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label,
          resetNestingLevel: ss.resetNestingLevel
        };
}

function setAllLabels(ss, allLabels) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: allLabels,
          readInstr: ss.readInstr,
          label: ss.label,
          resetNestingLevel: ss.resetNestingLevel
        };
}

function setReadInstr(ss, readInstr) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: readInstr,
          label: ss.label,
          resetNestingLevel: ss.resetNestingLevel
        };
}

function setLabel(ss, label) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: label,
          resetNestingLevel: ss.resetNestingLevel
        };
}

function addSingleScope(st, defaultSrcType) {
  return {
          nextId: st.nextId + 1 | 0,
          expanded: st.expanded,
          singleScopes: Belt_Array.concat(st.singleScopes, [createEmptySingleScope(String(st.nextId), defaultSrcType)]),
          loadedContextSummary: st.loadedContextSummary
        };
}

function updateSingleScope(st, id, update) {
  return {
          nextId: st.nextId,
          expanded: st.expanded,
          singleScopes: st.singleScopes.map(function (ss) {
                if (ss.id === id) {
                  return update(ss);
                } else {
                  return ss;
                }
              }),
          loadedContextSummary: st.loadedContextSummary
        };
}

function setExpanded(st, expanded) {
  return {
          nextId: st.nextId,
          expanded: expanded,
          singleScopes: st.singleScopes,
          loadedContextSummary: st.loadedContextSummary
        };
}

function setLoadedContextSummary(st, loadedContextSummary) {
  return {
          nextId: st.nextId,
          expanded: st.expanded,
          singleScopes: st.singleScopes,
          loadedContextSummary: loadedContextSummary
        };
}

function getNameFromFileSrc(src) {
  if (src === undefined) {
    return ;
  }
  if (src.TAG === "Local") {
    return src.fileName;
  }
  var match = src._0;
  var alias = match.alias;
  if (alias.trim() !== "") {
    return alias;
  } else {
    return match.url;
  }
}

function getSummary(st) {
  if (st.singleScopes.length === 1 && Belt_Option.isNone(st.singleScopes[0].fileSrc)) {
    return "No Metamath database is loaded; please select a database to load.";
  }
  var filesInfo = st.singleScopes.map(function (ss) {
        var name = Belt_Option.getWithDefault(getNameFromFileSrc(ss.fileSrc), "");
        var match = ss.readInstr;
        var readInstr;
        switch (match) {
          case "ReadAll" :
              readInstr = "";
              break;
          case "StopBefore" :
              readInstr = ", stopped before " + Belt_Option.getWithDefault(ss.label, "");
              break;
          case "StopAfter" :
              readInstr = ", stopped after " + Belt_Option.getWithDefault(ss.label, "");
              break;
          
        }
        return name + readInstr;
      });
  return "Loaded: " + filesInfo.join("; ");
}

function makeActTerminate(modalRef, modalId) {
  return function () {
    MM_wrk_client.terminateWorker();
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
}

var webTypStr = MM_wrk_editor.mmFileSourceTypeToStr("Web");

var localTypStr = MM_wrk_editor.mmFileSourceTypeToStr("Local");

function isReadInstrSame(ss, srcDto) {
  if (ss.readInstr === MM_wrk_editor.readInstrFromStr(srcDto.readInstr) && (ss.readInstr === "ReadAll" || Belt_Option.mapWithDefault(ss.label, false, (function (ssLabel) {
              return ssLabel === srcDto.label;
            })))) {
    return ss.resetNestingLevel === srcDto.resetNestingLevel;
  } else {
    return false;
  }
}

function isScopeSame(singleScopes, srcs) {
  if (singleScopes.length === srcs.length) {
    return singleScopes.every(function (ss, i) {
                var srcDto = srcs[i];
                var ssFileSrc = ss.fileSrc;
                if (ssFileSrc !== undefined) {
                  if (ssFileSrc.TAG === "Local") {
                    if (srcDto.typ === localTypStr && ssFileSrc.fileName === srcDto.fileName && isReadInstrSame(ss, srcDto)) {
                      var match = ss.ast;
                      if (match === undefined) {
                        return false;
                      }
                      if (match.TAG !== "Ok") {
                        return false;
                      }
                      var dtoAst = srcDto.ast;
                      if (dtoAst !== undefined) {
                        return match._0 === dtoAst;
                      } else {
                        return false;
                      }
                    } else {
                      return false;
                    }
                  } else if (srcDto.typ === webTypStr && ssFileSrc._0.url === srcDto.url) {
                    return isReadInstrSame(ss, srcDto);
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              });
  } else {
    return false;
  }
}

function canLoadContext(srcs) {
  if (srcs.length > 0) {
    return srcs.every(function (src) {
                if (Belt_Option.isSome(src.ast)) {
                  return true;
                } else {
                  return src.typ === webTypStr;
                }
              });
  } else {
    return false;
  }
}

function shouldReloadContext(singleScopes, srcs, force) {
  if (canLoadContext(srcs)) {
    if (force) {
      return true;
    } else {
      return !isScopeSame(singleScopes, srcs);
    }
  } else {
    return false;
  }
}

function parseMmFileForSingleScope(st, singleScopeId, modalRef) {
  var ss = st.singleScopes.find(function (ss) {
        return ss.id === singleScopeId;
      });
  if (ss !== undefined) {
    var src = ss.fileSrc;
    if (src !== undefined) {
      var match = ss.fileText;
      if (match !== undefined) {
        if (typeof match !== "object") {
          return Expln_utils_promise.promise(function (rsv) {
                      rsv(st);
                    });
        }
        var text = match._0;
        var name = Belt_Option.getExn(getNameFromFileSrc(src));
        var progressText = "Parsing " + name;
        return Expln_utils_promise.promise(function (rsv) {
                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                return MM_react_common.rndProgress(progressText, 0, undefined);
                              })), (function (modalId) {
                            var onTerminate = makeActTerminate(modalRef, modalId);
                            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                    return MM_react_common.rndProgress(progressText, 0, onTerminate);
                                  }));
                            MM_wrk_ParseMmFile.beginParsingMmFile(text, (function (pct) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                            return MM_react_common.rndProgress(progressText, pct, onTerminate);
                                          }));
                                  }), (function (parseResult) {
                                    var st$1;
                                    if (parseResult.TAG === "Ok") {
                                      var match = parseResult._0;
                                      var allLabels = match[1];
                                      var ast = match[0];
                                      var st$2 = updateSingleScope(st, ss.id, (function (__x) {
                                              return setAst(__x, {
                                                          TAG: "Ok",
                                                          _0: ast
                                                        });
                                            }));
                                      st$1 = updateSingleScope(st$2, ss.id, (function (__x) {
                                              return setAllLabels(__x, allLabels);
                                            }));
                                    } else {
                                      var msg = parseResult._0;
                                      var st$3 = updateSingleScope(st, ss.id, (function (__x) {
                                              return setAst(__x, {
                                                          TAG: "Error",
                                                          _0: msg
                                                        });
                                            }));
                                      st$1 = updateSingleScope(st$3, ss.id, (function (__x) {
                                              return setAllLabels(__x, []);
                                            }));
                                    }
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    rsv(st$1);
                                  }));
                          }));
                  });
      }
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "fileText is not set for the mmSingleScope with id '" + singleScopeId + "'"
            },
            Error: new Error()
          };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "fileSrc is not set for the mmSingleScope with id '" + singleScopeId + "'"
          },
          Error: new Error()
        };
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Could not find an mmSingleScope with id '" + singleScopeId + "'"
        },
        Error: new Error()
      };
}

function parseMmFileForSingleScopeRec(mmScope, modalRef, ssIdx) {
  if (ssIdx === mmScope.singleScopes.length) {
    return Expln_utils_promise.promise(function (rslv) {
                rslv({
                      TAG: "Ok",
                      _0: mmScope
                    });
              });
  }
  var ss = mmScope.singleScopes[ssIdx];
  return Expln_utils_promise.promiseFlatMap(parseMmFileForSingleScope(mmScope, ss.id, modalRef), (function (mmScope) {
                var ss$1 = mmScope.singleScopes.find(function (s) {
                      return s.id === ss.id;
                    });
                if (ss$1 !== undefined) {
                  var match = ss$1.ast;
                  if (match !== undefined) {
                    if (match.TAG === "Ok") {
                      return parseMmFileForSingleScopeRec(mmScope, modalRef, ssIdx + 1 | 0);
                    }
                    var msg = match._0;
                    return Expln_utils_promise.promise(function (rslv) {
                                rslv({
                                      TAG: "Error",
                                      _0: msg
                                    });
                              });
                  }
                  throw {
                        RE_EXN_ID: Common.MmException,
                        _1: {
                          msg: "Could not parse MM file for ss.id = " + ss$1.id
                        },
                        Error: new Error()
                      };
                }
                throw {
                      RE_EXN_ID: Common.MmException,
                      _1: {
                        msg: "None == singleScopes->find(s => s.id == ss.id)"
                      },
                      Error: new Error()
                    };
              }));
}

function scopeIsEmpty(singleScopes) {
  if (singleScopes.length === 1) {
    return Belt_Option.isNone(singleScopes[0].fileSrc);
  } else {
    return false;
  }
}

function loadMmContext(singleScopes, settings, modalRef, showError) {
  return Expln_utils_promise.promise(function (rsv) {
              if (scopeIsEmpty(singleScopes)) {
                return rsv({
                            TAG: "Ok",
                            _0: MM_context.createContext(undefined, undefined)
                          });
              }
              var progressText = "Loading MM context";
              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                          return MM_react_common.rndProgress(progressText, 0, undefined);
                        })), (function (modalId) {
                      var onTerminate = makeActTerminate(modalRef, modalId);
                      Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                              return MM_react_common.rndProgress(progressText, 0, onTerminate);
                            }));
                      MM_wrk_LoadCtx.beginLoadingMmContext(singleScopes.map(function (ss) {
                                var stopBefore = ss.readInstr === "StopBefore" ? ss.label : undefined;
                                var stopAfter = ss.readInstr === "StopAfter" ? ss.label : undefined;
                                var label = Belt_Option.getWithDefault(stopBefore, Belt_Option.getWithDefault(stopAfter, Belt_Option.getWithDefault(Belt_Array.get(ss.allLabels, ss.allLabels.length - 1 | 0), "")));
                                var match = ss.ast;
                                var tmp;
                                if (match !== undefined) {
                                  if (match.TAG === "Ok") {
                                    tmp = match._0;
                                  } else {
                                    throw {
                                          RE_EXN_ID: Common.MmException,
                                          _1: {
                                            msg: "Cannot load an MM context from an empty or error ast."
                                          },
                                          Error: new Error()
                                        };
                                  }
                                } else {
                                  throw {
                                        RE_EXN_ID: Common.MmException,
                                        _1: {
                                          msg: "Cannot load an MM context from an empty or error ast."
                                        },
                                        Error: new Error()
                                      };
                                }
                                return {
                                        ast: tmp,
                                        expectedNumOfAssertions: ss.allLabels.indexOf(label) + 1 | 0,
                                        stopBefore: stopBefore,
                                        stopAfter: stopAfter,
                                        resetNestingLevel: ss.resetNestingLevel
                                      };
                              }), settings.descrRegexToDisc, settings.labelRegexToDisc, settings.descrRegexToDepr, settings.labelRegexToDepr, (function (pct) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return MM_react_common.rndProgress(progressText, pct, onTerminate);
                                    }));
                            }), (function (ctx) {
                              if (ctx.TAG !== "Ok" && showError) {
                                var msg = ctx._0;
                                Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                            return null;
                                          })), (function (modalId) {
                                        Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                return React.createElement(Paper, {
                                                            style: {
                                                              padding: "10px"
                                                            },
                                                            children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                                      spacing: 1,
                                                                      children: Caml_option.some(null)
                                                                    }, "Error loading context:", React.createElement("pre", {
                                                                          style: {
                                                                            color: "red"
                                                                          }
                                                                        }, msg), React.createElement(Button, {
                                                                          onClick: (function (param) {
                                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                                            }),
                                                                          variant: "contained",
                                                                          children: "Ok"
                                                                        })))
                                                          });
                                              }));
                                      }));
                              }
                              rsv(ctx);
                              Expln_React_Modal.closeModal(modalRef, modalId);
                            }));
                    }));
            });
}

function loadMmFileText(modalRef, trustedUrls, onUrlBecomesTrusted, alias, url) {
  return Expln_utils_promise.promise(function (rslv) {
              FileLoader.loadFileWithProgress(modalRef, !trustedUrls.includes(url), onUrlBecomesTrusted, url, "Downloading MM file from \"" + alias + "\"", (function (text) {
                      rslv({
                            TAG: "Ok",
                            _0: text
                          });
                    }), (function (msg) {
                      rslv({
                            TAG: "Error",
                            _0: "An error occurred while downloading from \"" + alias + "\": " + Belt_Option.getWithDefault(msg, "") + "."
                          });
                    }), undefined, (function () {
                      rslv({
                            TAG: "Error",
                            _0: "Downloading from \"" + alias + "\" was terminated."
                          });
                    }));
            });
}

function loadMmFileTextForSingleScope(mmScope, modalRef, trustedUrls, onUrlBecomesTrusted, loadedTexts, ssIdx) {
  if (ssIdx === mmScope.singleScopes.length) {
    return Expln_utils_promise.promise(function (rslv) {
                rslv({
                      TAG: "Ok",
                      _0: mmScope
                    });
              });
  }
  var ss = mmScope.singleScopes[ssIdx];
  var $$continue = function (text) {
    var mmScope$1 = updateSingleScope(mmScope, ss.id, (function (__x) {
            return setFileText(__x, text);
          }));
    return loadMmFileTextForSingleScope(mmScope$1, modalRef, trustedUrls, onUrlBecomesTrusted, loadedTexts, ssIdx + 1 | 0);
  };
  var match = ss.fileSrc;
  if (match !== undefined) {
    if (match.TAG === "Local") {
      var match$1 = ss.ast;
      if (match$1 !== undefined) {
        return $$continue("UseAst");
      }
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot load MM file text for a Local fileSrc."
            },
            Error: new Error()
          };
    }
    var match$2 = match._0;
    var url = match$2.url;
    var text = Belt_HashMapString.get(loadedTexts, url);
    if (text !== undefined) {
      return $$continue({
                  TAG: "Text",
                  _0: text
                });
    } else {
      return Expln_utils_promise.promiseFlatMap(loadMmFileText(modalRef, trustedUrls, onUrlBecomesTrusted, match$2.alias, url), (function (res) {
                    if (res.TAG === "Ok") {
                      return $$continue({
                                  TAG: "Text",
                                  _0: res._0
                                });
                    }
                    var msg = res._0;
                    return Expln_utils_promise.promise(function (rslv) {
                                rslv({
                                      TAG: "Error",
                                      _0: msg
                                    });
                              });
                  }));
    }
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot load MM file text for a None fileSrc."
        },
        Error: new Error()
      };
}

function srcDtoToFileSrc(src, webSrcSettings) {
  if (src.typ === localTypStr) {
    return {
            TAG: "Local",
            fileName: src.fileName
          };
  }
  if (src.typ === webTypStr) {
    var match = webSrcSettings.find(function (ws) {
          return ws.url === src.url;
        });
    var tmp;
    if (match !== undefined) {
      var alias = match.alias;
      tmp = alias.trim() !== "" ? alias : src.url;
    } else {
      tmp = src.url;
    }
    return {
            TAG: "Web",
            _0: {
              alias: tmp,
              url: src.url
            }
          };
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot convert an mmCtxSrcDto to an mmFileSource."
        },
        Error: new Error()
      };
}

function makeMmScopeFromSrcDtos(modalRef, webSrcSettings, srcs, trustedUrls, onUrlBecomesTrusted, loadedTexts) {
  var mmScope = Core__Array.reduce(srcs, {
        nextId: 0,
        expanded: false,
        singleScopes: [],
        loadedContextSummary: ""
      }, (function (mmScope, src) {
          var mmScope$1 = addSingleScope(mmScope, MM_wrk_editor.mmFileSourceTypeFromStr(src.typ));
          var ssId = mmScope$1.singleScopes[mmScope$1.singleScopes.length - 1 | 0].id;
          var mmScope$2 = updateSingleScope(mmScope$1, ssId, (function (__x) {
                  return setFileSrc(__x, srcDtoToFileSrc(src, webSrcSettings));
                }));
          var mmScope$3 = updateSingleScope(mmScope$2, ssId, (function (__x) {
                  return setAst(__x, Belt_Option.map(src.ast, (function (ast) {
                                    return {
                                            TAG: "Ok",
                                            _0: ast
                                          };
                                  })));
                }));
          var mmScope$4 = updateSingleScope(mmScope$3, ssId, (function (__x) {
                  return setAllLabels(__x, src.allLabels);
                }));
          var mmScope$5 = updateSingleScope(mmScope$4, ssId, (function (__x) {
                  return setReadInstr(__x, MM_wrk_editor.readInstrFromStr(src.readInstr));
                }));
          var mmScope$6 = updateSingleScope(mmScope$5, ssId, (function (__x) {
                  return setLabel(__x, src.label);
                }));
          return updateSingleScope(mmScope$6, ssId, (function (__x) {
                        var resetNestingLevel = src.resetNestingLevel;
                        return {
                                id: __x.id,
                                srcType: __x.srcType,
                                fileSrc: __x.fileSrc,
                                fileText: __x.fileText,
                                ast: __x.ast,
                                allLabels: __x.allLabels,
                                readInstr: __x.readInstr,
                                label: __x.label,
                                resetNestingLevel: resetNestingLevel
                              };
                      }));
        }));
  return Expln_utils_promise.promiseFlatMap(loadMmFileTextForSingleScope(mmScope, modalRef, trustedUrls, onUrlBecomesTrusted, loadedTexts, 0), (function (res) {
                if (res.TAG === "Ok") {
                  return parseMmFileForSingleScopeRec(res._0, modalRef, 0);
                }
                var msg = res._0;
                return Expln_utils_promise.promise(function (rslv) {
                            rslv({
                                  TAG: "Error",
                                  _0: msg
                                });
                          });
              }));
}

var defaultValueOfDefaultSrcTypeStr = MM_wrk_editor.mmFileSourceTypeToStr("Web");

function MM_cmp_context_selector(props) {
  var onExpandedChange = props.onExpandedChange;
  var onChange = props.onChange;
  var onUrlBecomesTrusted = props.onUrlBecomesTrusted;
  var settings = props.settings;
  var modalRef = props.modalRef;
  var match = Local_storage_utils.useStateFromLocalStorageStr("ctx-selector-default-src-type", defaultValueOfDefaultSrcTypeStr);
  var setDefaultSrcTypeStr = match[1];
  var defaultSrcType = Belt_Option.getWithDefault(MM_wrk_editor.mmFileSourceTypeFromStrOpt(match[0]), "Web");
  var match$1 = React.useState(function () {
        return {
                nextId: 1,
                expanded: true,
                singleScopes: [createEmptySingleScope("0", defaultSrcType)],
                loadedContextSummary: ""
              };
      });
  var setState = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        return state;
      });
  var setPrevState = match$2[1];
  var prevState = match$2[0];
  React.useEffect((function () {
          setState(function (prev) {
                return setLoadedContextSummary(prev, getSummary(prev));
              });
        }), []);
  var actNewCtxIsReady = function (srcs, ctx) {
    setState(function (st) {
          var st$1 = setLoadedContextSummary(st, getSummary(st));
          setPrevState(function (param) {
                return st$1;
              });
          return st$1;
        });
    onChange(srcs, ctx);
  };
  var trustedUrls = settings.webSrcSettings.filter(function (s) {
          return s.trusted;
        }).map(function (s) {
        return s.url;
      });
  var actToggleAccordion = function () {
    setState(function (prev) {
          return setExpanded(prev, !prev.expanded);
        });
  };
  var actCloseAccordion = function () {
    setState(function (__x) {
          return setExpanded(__x, false);
        });
  };
  React.useEffect((function () {
          onExpandedChange(state.expanded);
        }), [state.expanded]);
  var rndSingleScopeSelectors = function () {
    var renderDeleteButton = state.singleScopes.length > 1 || Belt_Option.isSome(state.singleScopes[0].fileSrc);
    return state.singleScopes.map(function (singleScope) {
                var match = singleScope.ast;
                var tmp;
                tmp = match !== undefined && match.TAG !== "Ok" ? match._0 : undefined;
                return JsxPPXReactSupportU.createElementWithKey(singleScope.id, MM_cmp_context_selector_single.make, {
                            modalRef: modalRef,
                            availableWebSrcs: settings.webSrcSettings.filter(function (s) {
                                    return s.alias.trim().length > 0;
                                  }).map(function (s) {
                                  return {
                                          alias: s.alias,
                                          url: s.url
                                        };
                                }),
                            trustedUrls: trustedUrls,
                            onUrlBecomesTrusted: onUrlBecomesTrusted,
                            srcType: singleScope.srcType,
                            onSrcTypeChange: (function (srcType) {
                                if (state.singleScopes.length === 1) {
                                  setDefaultSrcTypeStr(function (param) {
                                        return MM_wrk_editor.mmFileSourceTypeToStr(srcType);
                                      });
                                }
                                setState(function (__x) {
                                      return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                    return {
                                                            id: __x.id,
                                                            srcType: srcType,
                                                            fileSrc: __x.fileSrc,
                                                            fileText: __x.fileText,
                                                            ast: __x.ast,
                                                            allLabels: __x.allLabels,
                                                            readInstr: __x.readInstr,
                                                            label: __x.label,
                                                            resetNestingLevel: __x.resetNestingLevel
                                                          };
                                                  }));
                                    });
                              }),
                            fileSrc: singleScope.fileSrc,
                            onFileChange: (function (src, text) {
                                var id = singleScope.id;
                                var st = updateSingleScope(state, id, (function (__x) {
                                        return setFileSrc(__x, src);
                                      }));
                                var st$1 = updateSingleScope(st, id, (function (__x) {
                                        return setFileText(__x, {
                                                    TAG: "Text",
                                                    _0: text
                                                  });
                                      }));
                                Expln_utils_promise.promiseMap(parseMmFileForSingleScope(st$1, id, modalRef), (function (st) {
                                        setState(function (param) {
                                              return st;
                                            });
                                      }));
                              }),
                            parseError: tmp,
                            readInstr: singleScope.readInstr,
                            onReadInstrChange: (function (readInstr) {
                                setState(function (__x) {
                                      return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                    return setReadInstr(__x, readInstr);
                                                  }));
                                    });
                              }),
                            label: singleScope.label,
                            onLabelChange: (function (labelOpt) {
                                setState(function (__x) {
                                      return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                    return setLabel(__x, labelOpt);
                                                  }));
                                    });
                              }),
                            allLabels: singleScope.allLabels,
                            renderDeleteButton: renderDeleteButton,
                            onDelete: (function () {
                                setState(function (__x) {
                                      var id = singleScope.id;
                                      var st_nextId = __x.nextId;
                                      var st_expanded = __x.expanded;
                                      var st_singleScopes = Belt_Array.keep(__x.singleScopes, (function (ss) {
                                              return ss.id !== id;
                                            }));
                                      var st_loadedContextSummary = __x.loadedContextSummary;
                                      var st = {
                                        nextId: st_nextId,
                                        expanded: st_expanded,
                                        singleScopes: st_singleScopes,
                                        loadedContextSummary: st_loadedContextSummary
                                      };
                                      if (st_singleScopes.length === 0) {
                                        return addSingleScope(st, defaultSrcType);
                                      } else {
                                        return st;
                                      }
                                    });
                              })
                          });
              });
  };
  var rndAddButton = function () {
    var thereIsAtLeastOneValidSingleScope = state.singleScopes.some(function (singleScope) {
          var match = singleScope.ast;
          if (match !== undefined && match.TAG === "Ok") {
            return true;
          } else {
            return false;
          }
        });
    if (thereIsAtLeastOneValidSingleScope) {
      return JsxPPXReactSupportU.createElementWithKey("add-button", IconButton, {
                  onClick: (function (param) {
                      setState(function (__x) {
                            return addSingleScope(__x, defaultSrcType);
                          });
                    }),
                  children: Caml_option.some(React.createElement(Add, {}))
                });
    } else {
      return null;
    }
  };
  var applyChanges = function (state, showError, settings) {
    if (scopeIsEmpty(state.singleScopes)) {
      return Expln_utils_promise.promise(function (rslv) {
                  setState(function (param) {
                        return state;
                      });
                  actNewCtxIsReady([], MM_context.createContext(undefined, undefined));
                  rslv({
                        TAG: "Ok",
                        _0: undefined
                      });
                });
    } else {
      return Expln_utils_promise.promiseMap(loadMmContext(state.singleScopes, settings, modalRef, showError), (function (res) {
                    if (res.TAG !== "Ok") {
                      return {
                              TAG: "Error",
                              _0: res._0
                            };
                    }
                    var mmCtxSrcDtos = state.singleScopes.map(function (ss) {
                          var src = ss.fileSrc;
                          if (src !== undefined) {
                            var match = ss.ast;
                            var ast;
                            if (match !== undefined) {
                              if (match.TAG === "Ok") {
                                ast = match._0;
                              } else {
                                throw {
                                      RE_EXN_ID: Common.MmException,
                                      _1: {
                                        msg: "Cannot create mmCtxSrcDto from empty ast."
                                      },
                                      Error: new Error()
                                    };
                              }
                            } else {
                              throw {
                                    RE_EXN_ID: Common.MmException,
                                    _1: {
                                      msg: "Cannot create mmCtxSrcDto from empty ast."
                                    },
                                    Error: new Error()
                                  };
                            }
                            if (src.TAG === "Local") {
                              return {
                                      typ: MM_wrk_editor.mmFileSourceTypeToStr("Local"),
                                      fileName: src.fileName,
                                      url: "",
                                      readInstr: MM_wrk_editor.readInstrToStr(ss.readInstr),
                                      label: Belt_Option.getWithDefault(ss.label, ""),
                                      resetNestingLevel: ss.resetNestingLevel,
                                      ast: ast,
                                      allLabels: ss.allLabels
                                    };
                            } else {
                              return {
                                      typ: MM_wrk_editor.mmFileSourceTypeToStr("Web"),
                                      fileName: "",
                                      url: src._0.url,
                                      readInstr: MM_wrk_editor.readInstrToStr(ss.readInstr),
                                      label: Belt_Option.getWithDefault(ss.label, ""),
                                      resetNestingLevel: ss.resetNestingLevel,
                                      ast: ast,
                                      allLabels: ss.allLabels
                                    };
                            }
                          }
                          throw {
                                RE_EXN_ID: Common.MmException,
                                _1: {
                                  msg: "ss.fileSrc is None"
                                },
                                Error: new Error()
                              };
                        });
                    setState(function (param) {
                          return state;
                        });
                    actNewCtxIsReady(mmCtxSrcDtos, res._0);
                    return {
                            TAG: "Ok",
                            _0: undefined
                          };
                  }));
    }
  };
  props.reloadCtx.current = (function (srcs, settings, forceOpt, showErrorOpt) {
      var force = forceOpt !== undefined ? forceOpt : false;
      var showError = showErrorOpt !== undefined ? showErrorOpt : false;
      if (!shouldReloadContext(prevState.singleScopes, srcs, force)) {
        return Expln_utils_promise.promise(function (rslv) {
                    rslv({
                          TAG: "Ok",
                          _0: undefined
                        });
                  });
      }
      var loadedTexts = Belt_HashMapString.fromArray(prevState.singleScopes.map(function (ss) {
                    var match = ss.fileSrc;
                    if (match === undefined) {
                      return ;
                    }
                    if (match.TAG === "Local") {
                      return ;
                    }
                    var match$1 = ss.fileText;
                    if (match$1 !== undefined && typeof match$1 === "object") {
                      return [
                              match._0.url,
                              match$1._0
                            ];
                    }
                    
                  }).filter(Belt_Option.isSome).map(Belt_Option.getExn));
      return Expln_utils_promise.promiseFlatMap(makeMmScopeFromSrcDtos(modalRef, settings.webSrcSettings, srcs, trustedUrls, onUrlBecomesTrusted, loadedTexts), (function (res) {
                    if (res.TAG === "Ok") {
                      return applyChanges(res._0, showError, settings);
                    }
                    var msg = res._0;
                    return Expln_utils_promise.promise(function (rslv) {
                                rslv({
                                      TAG: "Error",
                                      _0: msg
                                    });
                              });
                  }));
    });
  props.doToggle.current = actToggleAccordion;
  var rndSaveButtons = function () {
    var thereAreNoChanges = scopeIsEmpty(state.singleScopes) && scopeIsEmpty(prevState.singleScopes) || Caml_obj.equal(state.singleScopes, prevState.singleScopes);
    if (thereAreNoChanges) {
      return null;
    }
    var scopeIsCorrect = state.singleScopes.every(function (ss) {
          var match = ss.ast;
          if (match === undefined) {
            return false;
          }
          if (match.TAG !== "Ok") {
            return false;
          }
          var match$1 = ss.readInstr;
          switch (match$1) {
            case "ReadAll" :
                return true;
            case "StopBefore" :
            case "StopAfter" :
                return ss.label !== undefined;
            
          }
        });
    var scopeIsEmpty$1 = scopeIsEmpty(state.singleScopes);
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(React.createElement(Button, {
                          onClick: (function (param) {
                              Expln_utils_promise.promiseMap(applyChanges(state, true, settings), (function (res) {
                                      if (res.TAG === "Ok" && !scopeIsEmpty$1) {
                                        return actCloseAccordion();
                                      }
                                      
                                    }));
                            }),
                          variant: "contained",
                          disabled: !scopeIsCorrect && !scopeIsEmpty$1,
                          children: "Apply changes"
                        }))
              });
  };
  return React.createElement(Accordion, {
              expanded: state.expanded,
              children: null
            }, React.createElement(AccordionSummaryStyled.make, {
                  onClick: actToggleAccordion,
                  expandIcon: Caml_option.some(React.createElement(ExpandMore, {})),
                  children: state.loadedContextSummary
                }), React.createElement(AccordionDetails, {
                  children: React.createElement(Expln_React_Column.make, {
                        spacing: 2,
                        children: Caml_option.some(null)
                      }, rndSingleScopeSelectors(), rndAddButton(), rndSaveButtons())
                }));
}

var make = MM_cmp_context_selector;

exports.make = make;
/* webTypStr Not a pure module */
